import { GetterTree, MutationTree, ActionTree } from "vuex";
import { CityApi } from "@/services/api/CityApi";

class State {
  isCityBusy: boolean;
  cityItems: unknown [];
  cityItem: unknown;
}

// Создаем объект
const cityApi = new CityApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isCityBusy(state): boolean {
    return state.isCityBusy;
  },

  getCityItems(state): unknown[] {
    return state.cityItems;
  },

  getCityItem(state): unknown {
    return state.cityItem;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsCityBusy(state, payload: boolean) {
    state.isCityBusy = payload
  },

  setCityItems(state, payload: unknown[]) {
    state.cityItems = payload
  },

  setCityItem(state, payload: unknown) {
    state.cityItem = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{

  // Устанавливаем элемент
  setCityItem({ commit }, data: any) {
    commit('setCityItem', data);
  },
  
  // Список элементов
  getCityItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCityBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      cityApi.getCityItems(filter, sort, pagination)
        .then(
          (response:any) => {
            let allCity,fromIdx
            for (const i in response) {

              if (response[i].getCityId() == 4) {
                allCity = response[i]
                fromIdx = i
                commit('setCityItem', response[i]);
                break;
              }
            }

            response.splice(fromIdx,1)
            response.splice(0,0,allCity)
            commit('setCityItems', response);
            commit('setIsCityBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCityBusy', false);
            reject(error);
          }
        );
    });
  },

  // Получить элемент
  getCityItem({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCityBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};

    return new Promise((resolve, reject) => {

      // Получаем элемент
      cityApi.getCityItem(filter)
        .then(
          (response) => {
            commit('setCityItem', response);
            commit('setIsCityBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCityBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createCityItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCityBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      cityApi.createCityItem(data)
        .then(
          (response) => {
            commit('setIsCityBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCityBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateCityItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCityBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      cityApi.updateCityItem(data)
        .then(
          (response) => {
            commit('setIsCityBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCityBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteCityItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCityBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      cityApi.deleteCityItem(data)
        .then(
          (response) => {
            commit('setIsCityBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCityBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const CityModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default CityModule;